import "core-js/modules/es.array.includes.js";
import React from 'react';
import styled, { css } from 'styled-components';
import { ChevronDown } from '@finect/tabular-icons/chevronDown';
import { ChevronUp } from '@finect/tabular-icons/chevronUp';
import { getFont } from '@finect/tabular-utils/getFont';
var borderStyles = css(["border:1px solid ", ";border-radius:", ";box-shadow:inset 0 0 2px ", ";transition:all 0.3s ease-in-out;"], function (_ref) {
  var theme = _ref.theme,
    isFocused = _ref.isFocused;
  return isFocused ? theme.colors.primaryM : theme.colors.terciaryM;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme,
    isFocused = _ref3.isFocused;
  return isFocused ? theme.colors.primaryM : theme.colors.terciaryM;
});
var smallStyles = css(["", ";padding:", ";svg{top:1px;}"], getFont(-1, 'default'), function (_ref4) {
  var withBorder = _ref4.withBorder;
  return withBorder && '6px';
});
var mediumStyles = css(["", ";padding:", ";svg{top:3px;}"], getFont(0, 'default'), function (_ref5) {
  var withBorder = _ref5.withBorder;
  return withBorder && '9px';
});
var Inner = styled.div.withConfig({
  displayName: "CurrentSelection__Inner",
  componentId: "sc-1r4ijnl-0"
})(["display:flex;", " border-radius:", ";font-weight:", ";color:", ";background-color:", ";", " svg{", " position:relative;top:3px;left:4px;margin-left:auto;margin-right:4px;}", " ", ""], function (_ref6) {
  var withPadding = _ref6.withPadding;
  return withPadding ? "padding: 7px 9px;" : '';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.borderRadius;
}, function (_ref8) {
  var fontWeight = _ref8.fontWeight;
  return fontWeight;
}, function (_ref9) {
  var theme = _ref9.theme,
    withColor = _ref9.withColor;
  return withColor === 'terciary' ? theme.colors.terciaryD : withColor === 'white' ? '#fff' : theme.colors[withColor];
}, function (_ref10) {
  var theme = _ref10.theme,
    backgroundColor = _ref10.backgroundColor;
  return backgroundColor === 'secondary' ? theme.colors.secondary : backgroundColor === 'white' ? '#fff' : 'transparent';
}, function (_ref11) {
  var withBorder = _ref11.withBorder;
  return withBorder && borderStyles;
}, function (_ref12) {
  var theme = _ref12.theme,
    chevronColor = _ref12.chevronColor,
    withColor = _ref12.withColor;
  return chevronColor !== withColor ? "stroke: ".concat(theme.colors[chevronColor], ";") : '';
}, function (_ref13) {
  var size = _ref13.size;
  return ['small'].includes(size) && smallStyles;
}, function (_ref14) {
  var size = _ref14.size;
  return ['medium'].includes(size) && mediumStyles;
});
export var CurrentSelection = function CurrentSelection(_ref15) {
  var fontWeight = _ref15.fontWeight,
    size = _ref15.size,
    open = _ref15.open,
    label = _ref15.label,
    _onClick = _ref15.onClick,
    withBorder = _ref15.withBorder,
    withPadding = _ref15.withPadding,
    _ref15$color = _ref15.color,
    color = _ref15$color === void 0 ? 'primary' : _ref15$color,
    _ref15$chevronColor = _ref15.chevronColor,
    chevronColor = _ref15$chevronColor === void 0 ? 'primary' : _ref15$chevronColor,
    backgroundColor = _ref15.backgroundColor;
  return React.createElement(Inner, {
    fontWeight: fontWeight,
    size: size,
    onClick: function onClick() {
      return _onClick();
    },
    withBorder: withBorder,
    withPadding: withPadding,
    withColor: color,
    chevronColor: chevronColor,
    backgroundColor: backgroundColor
  }, React.createElement("span", null, label), open ? React.createElement(ChevronUp, {
    size: "20",
    strokeWidth: "2.4"
  }) : React.createElement(ChevronDown, {
    size: "20",
    strokeWidth: "2.4"
  }));
};